export const CURRENT_YEAR = new Date().getFullYear()
export const EMAIL = "info@strikeoff.ru"
export const PHONE = "+7 495 225 76 50"
export const GET_FORM_API =
  "https://getform.io/f/6b00035b-d067-4e45-8f8c-7aef98c4e692"
